import React from 'react';
import { useTranslation } from 'react-i18next';

import ParagraphCTA from '../../../implementations/Paragraph/CTA/Default';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const CampaignBlock = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_slogan', 0, 'value']);
  const languageCode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = entity.getIn(['paths', languageCode]);

  return (
    <div className="CampaignBlock">
      <ParagraphCTA
        entity={entity}
        titleOverwrite={title}
        variantOverwrite="one"
        linkTitleOverwrite={t('general.read_more')}
        linkHrefOverwrite={path}
      />
    </div>
  );
};

export default CampaignBlock;
